import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import GetDistricts from "../../Dropdowns/getDistricts";

const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];

const API_URL_FPS = process.env.REACT_APP_URL_HEADER;
const API_URL = process.env.REACT_APP_URL;



const BankUnfreeze = () => {
    const [form, setForm] = useState({
        district: '',
        distMonth: '',
        distYear: '',
        allotMonth: '',
        allotYear: ''
    });
    const [submitted, setSubmitted] = useState({
        districtCode: '',
        districtName: '',
        distMonth: '',
        distYear: '',
        allotMonth: '',
        allotYear: ''
    });

    const [currentMonth, setCurrentMonth] = useState(null);
    const [currentYear, setCurrentYear] = useState(null);
    const [status, setStatus] = useState(null);
    const [loading, setLoading] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [districtLoading, setDistrictLoading] = useState(true);

    const [selectedDistrictName, setSelectedDistrictName] = useState('');

    useEffect(() => {
        const loadDate = async () => {
            try {
                const [mRes, yRes] = await Promise.all([
                    axios.get(`${API_URL_FPS}/Common/currentMonth`),
                    axios.get(`${API_URL_FPS}/Common/currentYear`)
                ]);
                setCurrentMonth(parseInt(mRes.data));
                setCurrentYear(parseInt(yRes.data));
            } catch (err) {
                alert("Failed to load current date");
                console.error(err);
            }
        };
        loadDate();
    }, []);

    const prevMonth = currentMonth === 1 ? 12 : currentMonth - 1;
    const prevYear = currentMonth === 1 ? currentYear - 1 : currentYear;

    const prev2Month =
        currentMonth === 1 ? 11 :
            currentMonth === 2 ? 12 :
                currentMonth - 2;

    const prev2Year =
        currentMonth === 1 || currentMonth === 2
            ? currentYear - 1
            : currentYear;

    // Modified to receive both code and name
    // const handleDistrictChange = (districtCode) => {
    //     setForm(prev => ({ ...prev, district: districtCode }));

    //     // Find the selected option and extract name
    //     const selectElement = document.querySelector('#dist_code');
    //     if (selectElement) {
    //         const selectedOption = selectElement.options[selectElement.selectedIndex];
    //         const name = selectedOption ? selectedOption.textContent || selectedOption.innerText : '';
    //         setSelectedDistrictName(name);
    //     }
    // };

    const handleDistrictChange = (districtCode) => {
        setForm(prev => ({ ...prev, district: districtCode }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!form.district) {
            alert("Please select district");
            return;
        }

        setLoading(true);

        try {
            const res = await axios.post(`${API_URL}/api/unfreeze/status`, form);

            setStatus(res.data);

            setSubmitted({
                districtCode: form.district,
                districtName: res.data.districtName,
                distMonth: form.distMonth,
                distYear: form.distYear,
                allotMonth: form.allotMonth,
                allotYear: form.allotYear
            });

        } catch (err) {
            alert("Error: " + (err.response?.data || err.message));
        } finally {
            setLoading(false);
        }
    };


    const handleUnfreeze = async () => {
        try {
            const res = await axios.post(`${API_URL}/api/unfreeze/execute`, form);
            if (res.data.includes("SUCCESS")) {
                alert("Unfreezed successfully!");
                setStatus(null);
                setSelectedDistrictName(''); // reset
            } else {
                alert("Failed: " + res.data);
            }
        } catch (err) {
            alert("Error: " + (err.response?.data || err.message));
        } finally {
            setDialogOpen(false);
        }
    };

    if (!currentMonth || !currentYear) {
        return <div>Loading current date...</div>;
    }

    return (
        <div className="container" style={{ padding: '20px' }}>
            <form onSubmit={handleSubmit}>
                <table width="100%" align="center" cellPadding="8" cellSpacing="0" style={{ border: '1px solid #ccc' }}>
                    <thead>
                        <tr className="tableheader" style={{ backgroundColor: '#003366', color: 'white' }}>
                            <th colSpan="11">Unfreeze Commission Details</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><b>District:</b></td>
                            <td>
                                <GetDistricts
                                    onLoadingChange={setDistrictLoading}
                                    onChange={handleDistrictChange}
                                    value={form.district}
                                    required
                                />
                            </td>

                            <td><b>Dist Month:</b></td>
                            <td>
                                <select
                                    value={form.distMonth}
                                    onChange={e => setForm({ ...form, distMonth: +e.target.value })}
                                    required
                                >
                                    <option value="">-- Month --</option>

                                    <option value={currentMonth}>
                                        {monthNames[currentMonth - 1]}
                                    </option>

                                    <option value={prevMonth}>
                                        {monthNames[prevMonth - 1]}
                                    </option>

                                    <option value={prev2Month}>
                                        {monthNames[prev2Month - 1]}
                                    </option>
                                </select>

                            </td>

                            <td><b>Dist Year:</b></td>
                            <td>
                                <select value={form.distYear} onChange={e => setForm({ ...form, distYear: e.target.value })} required>
                                    <option value="">-- Year --</option>
                                    {prevYear !== currentYear && <option value={prevYear}>{prevYear}</option>}
                                    <option value={currentYear}>{currentYear}</option>
                                </select>
                            </td>

                            <td><b>Allot Month:</b></td>
                            <td>
                                <select value={form.allotMonth} onChange={e => setForm({ ...form, allotMonth: e.target.value })} required>
                                    <option value="">-- Month --</option>
                                    {monthNames.map((m, i) => (
                                        <option key={i + 1} value={i + 1}>{m}</option>
                                    ))}
                                </select>
                            </td>

                            <td><b>Allot Year:</b></td>
                            <td>
                                <select value={form.allotYear} onChange={e => setForm({ ...form, allotYear: e.target.value })} required>
                                    <option value="">-- Year --</option>
                                    <option value={currentYear - 1}>{currentYear - 1}</option>
                                    <option value={currentYear}>{currentYear}</option>
                                </select>
                            </td>

                            <td>
                                <button type="submit" className="button button2" disabled={loading || districtLoading}>
                                    {loading ? 'Checking...' : 'Submit'}
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </form>

            {status && (
                <table width="100%" cellPadding="8" cellSpacing="0" style={{ marginTop: '20px', border: '1px solid #ccc' }}>
                    <thead>
                        <tr class="tableheader">
                            <th colSpan="5">
                                Unfreeze Commission Details for {selectedDistrictName || status.districtName} 
                                <span style={{ fontSize: "20px" }}></span>
                                ({monthNames[submitted.distMonth - 1]} {submitted.distYear})
                            </th>
                        </tr>
                        <tr class="tableheader">
                            <th>District</th>
                            <th>Dist Month</th>
                            <th>Allot Month</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {status.canUnfreeze === true ? (
                            <tr align="center">
                                <td><strong>{status.districtName}</strong></td>
                                <td>{monthNames[form.distMonth - 1]} {form.distYear}</td>
                                <td>{monthNames[form.allotMonth - 1]} {form.allotYear}</td>
                                <td style={{ color: 'green', fontWeight: 'bold' }}>FREEZED</td>
                                <td>
                                    <button onClick={() => setDialogOpen(true)} className="button button2">
                                        Unfreeze
                                    </button>
                                </td>
                            </tr>
                        ) : (
                            <tr>
                                <td colSpan="5" style={{ textAlign: 'center', padding: '20px', color: 'black' }}>
                                    <strong>
                                        {status.message || "Statement is Downloaded already."}
                                    </strong>
                                </td>
                            </tr>
                        )}

                    </tbody>
                </table>
            )}


            <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
                <DialogTitle>Confirm Unfreeze</DialogTitle>
                <DialogContent>
                    <p>Are you sure you want to <strong>UNFREEZE</strong> this month?</p>
                    <p>
                        District: <strong>{status?.districtName || selectedDistrictName}</strong><br />
                        Dist Month: <strong>{monthNames[form.distMonth - 1]} {form.distYear}</strong><br />
                        Allot Month: <strong>{monthNames[form.allotMonth - 1]} {form.allotYear}</strong>
                    </p>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
                    <Button onClick={handleUnfreeze} color="error" variant="contained">
                        Yes, Unfreeze
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default BankUnfreeze;